<template>
  <div class="invoice-detail">
    <div class="invoice_detail_title">
      <div class="title_title">发票总额</div>
      <div class="title_amount">
        <span>{{ total }}</span>
        <span class="title_amount_unit">元</span>
      </div>
    </div>
    <div class="invoice_detail_content">
      <div v-for="(item, index) of list" :key="index">
        <div class="content_item">
          <div class="content_item_left">发票内容</div>
          <div class="content_item_right">{{ item.itemName }}</div>
        </div>
        <div class="content_item">
          <div class="content_item_left">对应金额</div>
          <div class="content_item_right">{{ item.totalAmount +'元' }}</div>
        </div>
      </div>
      <div class="content_item">
        <div class="content_item_left">合计金额</div>
        <div class="content_item_right total_amount">{{ total+'元' }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "invoiceDetail",
    props: {
      list: {
        type: Array,
        default: () => {
          return []
        }
      },
      total: {
        type: String,
        default: ''
      }
    }
  }
</script>

<style lang="scss" scoped>
  .invoice-detail {
    background:rgba(255,255,255,1);
    box-shadow: 0 2px 6px rgba(0,0,0,0.05);
    border-radius:10px;
    font-family:PingFang SC;

    // 顶部
    .invoice_detail_title {
      height: 120px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      border-bottom: 1px dashed #ccc;
      .title_title {
        color: #999;
        font-size:12px;
        line-height: 17px;
        margin-bottom: 8px;
      }
      .title_amount {
        font-size: 30px;
        font-weight: bold;
        .title_amount_unit {
          font-size: 12px;
        }
      }
    }
    // 底部
    .invoice_detail_content {
      padding: 16px 8px 10px;
      .content_item {
        display: flex;
        align-items: center;
        line-height: 17px;
        justify-content: space-between;
        font-size: 12px;
        color: #373737;
        margin-bottom: 12px;
        .content_item_right {
          color: #999;
          &.total_amount {
            color: #FF8A49;
          }
        }
      }
    }
  }
</style>
